import ActionButton from '@/src/components/misc/action-elements/action-button/action-button'
import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import OtpInput from '@/src/components/misc/otp-input/otp-input'
import BottomSheet from '@/src/components/helpers/overlays/bottom-sheet/bottom-sheet'
import SvgClose from '@/src/assets/svgs/collection/close-circle.svg'
import { Overlay } from '@/src/components/helpers/overlays/overlay'

interface Props {
    setOtpCode(e: string): void
    submit(otpCode: string): void
    resendOtp(e: React.FormEvent, isOtp: boolean): void
    back(): void
    closeModalAfterNewCodeSended(): void
    isLoading: boolean
    resendingOtp: boolean
    isNewOtpSended: boolean
    email: string
}

export default function OtpCode(props: Props) {
    const [otpCode, setOtpCode] = useState<string>('')
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        if (otpCode) {
            props.setOtpCode(otpCode)

            if (otpCode.length >= 6)
                props.submit(otpCode)
        }
    }, [otpCode])

    useEffect(() => {
        if (props.isNewOtpSended) {
            Overlay.dismiss()
            props.closeModalAfterNewCodeSended()
        }
    }, [props.isNewOtpSended])

    return (
        <>
            {
                isOpen &&
                <BottomSheet isOpen={isOpen} onClose={() => setIsOpen(false)}>
                    <div className={styles.bottomSheetContainer}>
                        <SvgClose className={styles.svgClose} onClick={() => Overlay.dismiss()} />
                        <div className={styles.emailInfo}>
                            <h3 className='font-md'>Enviamos um código para:</h3>
                            <b>{props?.email}</b>
                        </div>
                        <ActionButton
                            isLoading={props.resendingOtp}
                            onClick={(e) => props.resendOtp(e, true)}
                            className={styles.btn}
                            size='medium'
                        >
                            Reenviar código
                        </ActionButton>
                        <ActionButton
                            onClick={() => props.back()}
                            className={styles.btn}
                            size='medium'
                            theme='inverted'
                        >
                            Alterar e-mail
                        </ActionButton>
                    </div>
                </BottomSheet>
            }
            <div className={styles.container}>
                <div className={styles.emailInfo}>
                    <h3 className='font-md'>Enviamos um código para:</h3>
                    <b>{props?.email}</b>
                </div>

                <div className={styles.inputArea}>
                    <span>Digite o código enviado:</span>
                    <OtpInput
                        value={otpCode}
                        onChange={setOtpCode}
                        length={6}
                    />
                </div>

                <ActionButton
                    isLoading={props.isLoading}
                    onClick={() => props.submit(otpCode)}
                    className={styles.btn}
                    size='medium'
                    disabled={otpCode.length < 6}
                >
                    Entrar
                </ActionButton>

                <div className={styles.forgotPassword}>
                    <span className='font-sm'>Não recebou o código? <u onClick={() => setIsOpen(true)}>Tentar novamente</u></span>
                </div>
            </div>
        </>
    )
}